import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigatorMain from './NavigatorMain';
import { hashHistory } from 'react-router';
import { Player } from 'video-react';

const width = window.screen.width
let ua=navigator.userAgent.toLowerCase()
class Understand extends Component {
  constructor(props){
      super(props);
  }
  componentWillMount() {
  }
  goBack(){
    if (ua.indexOf("amcfmapp")>-1) {
      if (ua.indexOf("wkwebview")>-1) {
        if (window.webkit) {
          window.webkit.messageHandlers.amcfm_utils.postMessage({"refreshHome":"intelInvest"});
          window.webkit.messageHandlers.amcfm_utils.postMessage({"finish":""});
        }
      }else{
        if (window.amcfm_utils) {
          window.amcfm_utils.refreshHome('intelInvest');
          window.amcfm_utils.finish();
        }
      }
    }else {
      // hashHistory.goBack();
      hashHistory.go(1-window.historyData.length);
    }
  }    
  render(){
    return(
      <div className="container">
        <NavigatorMain>
          <div className="header" style={{backgroundColor:'rgba(211,211,211,0)'}}>
            <div style={{ WebkitFlex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, textAlign:'center', fontSize:"0.3rem" }}>一分钟了解华夏查理智投</div>
            <div style={{ WebkitFlex:1, textAlign:'right', fontSize:"0.28rem", paddingRight:'13px' }}></div>    
          </div>
        </NavigatorMain>
        <div className="content" style={{paddingBottom:40}}>
          <div className="understand-bg">
            <img style={{width: 63, height: 63}} src={require('../img/jqrIcon.png')} />
            <div style={{backgroundColor:'rgba(0,0,0,0.2)',borderRadius:10,width:width- 110,justifyContent:'center',color:'#fff',fontSize:14,lineHeight:'23px',padding:7}}>
             华夏查理智投组合是在华夏基金21年资产管理经验的基础上，融入智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。
            </div>
          </div>
          <div style={{padding:10}}>
            <Player>
              <source src="https://www.amcfortune.com/minipage/mdzt/mdzt.mp4" />
            </Player>
          </div>
          <img style={{width:width}} src={require('../img/icon34.png')}/>
        </div>
        <div onClick={ ()=> this.goBack() } style={{ height:40,backgroundColor:'#fa063a',width:width,position:'fixed',bottom:0,textAlign:'center',color:'#fff',lineHeight:'40px'}}>
          立即体验
        </div>
      </div>
    )
  }
}
function mapStateToProps(state, ownProps) {
    return {
      
    }
  }
  
  export default connect(mapStateToProps)(Understand);


// WEBPACK FOOTER //
// ./src/components/Understand.js